import clsx from 'clsx';

import React from 'react';

import { slides, wrapper } from './infinite-carousel.css';

type InfiniteCarouselProps = React.PropsWithChildren<{
  direction: 'vertical' | 'horizontal' | 'vertical-reverse';
  classNames?: { wrapper?: string; slides?: string };
}>;

export function InfiniteCarousel({
  direction,
  classNames,
  children,
}: InfiniteCarouselProps) {
  const group = (
    <section className={clsx(slides, classNames?.slides)}>{children}</section>
  );

  return (
    <section
      data-direction={direction}
      className={clsx(wrapper, classNames?.wrapper)}
    >
      {group}
      {group}
    </section>
  );
}
